import React from 'react';
import { Menu } from 'antd';
import {
    FundProjectionScreenOutlined,
    UserOutlined,
    ContainerOutlined,
    LogoutOutlined,
    AuditOutlined,
    FileProtectOutlined,
    GroupOutlined,
    CarOutlined
} from '@ant-design/icons'
import * as Constants from '../../../constants';
import './styles.css';

const { SubMenu } = Menu;

const MainMenuAdmin = ({ onItemClick, itemSelected }) => {
    return (
        <Menu className="MainMenuCont" theme="dark" defaultSelectedKeys={[itemSelected]} mode="horizontal">
            <Menu.Item key={`/`} onClick={() => {onItemClick({itemClickType: Constants.MenuAdmin.USERS})}}>
                <UserOutlined />
                <span>Usuarios</span>
            </Menu.Item>
            <SubMenu
            key="sub1"
            title={
                <span>
                    <ContainerOutlined />
                    <span>Encuestas</span>
                </span>
            }>
                <Menu.Item key={`/${Constants.MenuAdmin.SURVEYS.STATISTICS}`} onClick={() => {onItemClick({itemClickType: Constants.MenuAdmin.SURVEYS.STATISTICS})}}><FundProjectionScreenOutlined /><span>Resueltas</span></Menu.Item>
                <Menu.Item key={`/${Constants.MenuAdmin.SURVEYS.SURVEYS_USERS}`} onClick={() => {onItemClick({itemClickType: Constants.MenuAdmin.SURVEYS.SURVEYS_USERS})}}><AuditOutlined /><span>Administrar</span></Menu.Item>
                <Menu.Item key={`/${Constants.MenuAdmin.SURVEYS.TEMPLATES}`} onClick={() => {onItemClick({itemClickType: Constants.MenuAdmin.SURVEYS.TEMPLATES})}}><FileProtectOutlined /><span>Plantillas</span></Menu.Item>
            </SubMenu>
            <Menu.Item key={`/${Constants.MenuAdmin.INVENTORY.HOME}`} onClick={() => {onItemClick({itemClickType: Constants.MenuAdmin.INVENTORY.HOME})}}>
                <GroupOutlined />
                <span>Inventario</span>
            </Menu.Item>
            <Menu.Item key={`/${Constants.MenuAdmin.INVENTORY_HISTORICAL}`} onClick={() => {onItemClick({itemClickType: Constants.MenuAdmin.INVENTORY_HISTORICAL})}}>
                <CarOutlined  />
                <span>Movilidades - Históricos</span>
            </Menu.Item>
            <Menu.Item key={`/${Constants.MenuAdmin.LOGOUT}`} onClick={() => {onItemClick({itemClickType: Constants.MenuAdmin.LOGOUT})}}>
                <LogoutOutlined />
                <span>Cerrar sesión</span>
            </Menu.Item>
        </Menu>
    );
};

MainMenuAdmin.propTypes = {

};

export default MainMenuAdmin;
